module.exports = __webpack_public_path__ + "img/home-bg.bb05e51e.png";